export const validateHeaders = (header) =>
  header.every((h, i) => {
    const b = h.toLowerCase().trim() === [`name`, `email`, `address`, `city`, `state`, `zip`, `type`, `nabcep_ids`][i]
    return b
  })
